
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model/[make]/[year]/[model]/compare-trims",
      function () {
        return require("private-next-pages/model/[make]/[year]/[model]/compare-trims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/model/[make]/[year]/[model]/compare-trims"])
      });
    }
  